import IWorkFile from '@/models/fact-sheet/IWorkFile';
import FactSheetPropertyUtils from './FactSheetPropertyUtils';

export default {
    reorderSubjectFirst(workFile: IWorkFile, subjectAddress1AndUnitNo: string) {
        let startIndex = 0;
        for (const factSheetProperty of workFile) {
            const propertyAddress1AndUnitNo = FactSheetPropertyUtils.combineTransferAddress1AndUnitNo(factSheetProperty);
            if (propertyAddress1AndUnitNo === subjectAddress1AndUnitNo) {
                workFile.splice(0, 0, workFile.splice(startIndex, 1)[0]);
            }
            startIndex++;
        }
    }
};
